import type { CSSProperties } from 'react';
import { COLORS } from './colors';
import { FONTS } from './typography';

/** Shared player-facing material, matching the creator and saved-character roster. */
export const PLAYER_UI = {
  inkDeep: '#090b12', ink: '#111522', inkRaised: '#181d2a', well: '#0d1019',
  text: '#f4f0e7', secondary: '#c4c4c9', muted: '#a4a7ad',
  brass: '#c9a35c', brassBright: '#f0d18a',
  border: 'rgba(216,181,106,0.24)', softBorder: 'rgba(255,255,255,0.09)',
  success: COLORS.success, danger: COLORS.danger,
  displayFont: FONTS.display, bodyFont: "'Inter', 'Segoe UI', sans-serif",
} as const;

export const PLAYER_THEME_VARS = {
  '--player-ink-deep': PLAYER_UI.inkDeep, '--player-ink': PLAYER_UI.ink,
  '--player-ink-raised': PLAYER_UI.inkRaised, '--player-well': PLAYER_UI.well,
  '--player-text': PLAYER_UI.text, '--player-secondary': PLAYER_UI.secondary,
  '--player-muted': PLAYER_UI.muted, '--player-brass': PLAYER_UI.brass,
  '--player-brass-bright': PLAYER_UI.brassBright, '--player-border': PLAYER_UI.border,
  '--player-soft-border': PLAYER_UI.softBorder, '--player-display-font': PLAYER_UI.displayFont,
  '--player-body-font': PLAYER_UI.bodyFont,
} as CSSProperties;

export function playerPanel(): CSSProperties {
  return { ...PLAYER_THEME_VARS,
    background: `linear-gradient(180deg, ${PLAYER_UI.inkRaised}, ${PLAYER_UI.ink} 55%, ${PLAYER_UI.inkDeep})`,
    color: PLAYER_UI.text, border: `1px solid ${PLAYER_UI.border}`, borderRadius: 14,
    boxShadow: '0 18px 54px rgba(0,0,0,0.38), inset 0 1px 0 rgba(255,255,255,0.035)',
    fontFamily: PLAYER_UI.bodyFont,
  };
}

/** Existing creator/roster CSS keeps its layout while reading one palette. */
/* The screens before the game are the book's cover: leather and gilt, from the tome tokens. Their
   panels re-point these same names to parchment (CharacterSelectScreen.css, login.css). */
const COVER_MUTED = 'color-mix(in srgb, var(--tome-paper-mid) 72%, var(--tome-cover-hi))';
const COVER_LINE = 'color-mix(in srgb, var(--tome-gilt) 34%, transparent)';
export const CREATOR_THEME_VARS = {
  '--cc-ink-deep': 'var(--tome-cover-lo)', '--cc-ink': 'var(--tome-cover-lo)',
  '--cc-ink-raised': 'var(--tome-cover-hi)', '--cc-brass': 'var(--tome-gilt)',
  '--cc-brass-bright': 'var(--tome-gilt-bright)', '--cc-text': 'var(--tome-paper-hi)',
  '--cc-muted': COVER_MUTED, '--cc-line': COVER_LINE, '--cc-soft-line': 'color-mix(in srgb, var(--tome-gilt) 16%, transparent)',
} as CSSProperties;
export const ROSTER_THEME_VARS = {
  '--roster-ink': 'var(--tome-cover-lo)', '--roster-brass': 'var(--tome-gilt)',
  '--roster-bright': 'var(--tome-gilt-bright)', '--roster-text': 'var(--tome-paper-hi)',
  '--roster-muted': COVER_MUTED, '--roster-line': COVER_LINE,
} as CSSProperties;
